import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.99 13a3 3 0 0 0-3-3h-1.3a3 3 0 0 0-2.968 2.565c-.492 3.357-.738 7.191-.741 11.505-.003 4.297.236 8.085.718 11.366A3 3 0 0 0 11.667 38h1.323a3 3 0 0 0 3-3V13Zm21.457.722a3 3 0 0 0-4.571-2.21l-15.232 9.52a3.5 3.5 0 0 0 .002 5.938l15.252 9.519a3 3 0 0 0 4.57-2.212c.357-3.203.534-6.607.532-10.213-.002-3.626-.187-7.073-.553-10.342Z",
      clipRule: "evenodd"
    }
  )
);
var SvgSkipPreviousFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SkipPreviousFilled_default = SvgSkipPreviousFilled;

export { SkipPreviousFilled_default as default };
